import { createSelector } from 'reselect';
import { COLUMN_TYPE, buildColumn } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';

export const getDimensionColumns = (dimensionKeys: string[], options?: ColumnOptions): IColumn[] => {
  return dimensionKeys.map((key) => buildColumn({ type: COLUMN_TYPE.DIMENSION, key, ...options }));
};

export const createDimensionColumnsSelector = (
  getDimensionKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getDimensionKeys, getColumnOptions, getDimensionColumns);
};
